import script from "./BaseIconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseIconButton.vue?vue&type=script&lang=ts&setup=true"

import "./BaseIconButton.vue?vue&type=style&index=0&id=fd98c268&lang=scss"

const __exports__ = script;

export default __exports__